// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__3d72q","label":"styles_label__1_59h","icon":"styles_icon__1tLl3","checked":"styles_checked__jRbvQ"};